/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 서버 통신으로 관심단지와 관련된 내용을 지원합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import APIClient from 'common-modules/general/Model/APIClientModel';
import { cdBizLnd } from 'data/configs';

import {
  RequestDeleteSpecificWatchListAPI,
  RequestUpdateWatchListAPI,
  ResponseDeleteSpecificWatchListAPI,
  ResponseGetAllWatchListAPI,
  ResponseUpdateWatchListAPI,
  RequestEditWatchList,
  ResponseResultCode,
  ResponseWatchlist
} from './types';

export const updateWatchList = (data: RequestUpdateWatchListAPI) =>
  APIClient.watchList.post<ResponseUpdateWatchListAPI>('/edit', data);
export const getAllWatchList = () => APIClient.watchList.get<ResponseGetAllWatchListAPI>('/all');
export const deleteSpecificWatchList = (data: RequestDeleteSpecificWatchListAPI) =>
  APIClient.watchList.post<ResponseDeleteSpecificWatchListAPI>('/delete', data);

/**
 * @token_필요
 * 특정 유저 관심단지 정보 가져오기
 */
export const getWatchList = () => APIClient.watchList.get<ResponseWatchlist[]>(`/`, { params: { cdBizLnd } });

/**
 * @token_필요
 * 특정 유저 관심단지 수정
 */
export const editWatchList = (data: RequestEditWatchList['watchList'], type: 'P' | 'M', agree?: any,) =>
  APIClient.watchList.post<ResponseResultCode>(`/edit`, {
    cdBizLnd,
    watchList: data,
    type: type,
    ynSmsRcpn: agree?.ynSmsRcpn,
    ynEmailRcpn: agree?.ynEmailRcpn
  });
